@let $content = content();

<mbs-text-ellipsis
  class="d-block"
  [placement]="'top-left auto'"
  [tooltip]="$content"
  [tooltipClass]="'tooltip-lg'">
  {{ $content }}
  <ng-template mbsTextEllipsisAppend>
    <mbs-copy-button
      class="ml-1"
      [isCtrl]="true"
      (mbsClipboard)="handleCopy()">
    </mbs-copy-button>
  </ng-template>
</mbs-text-ellipsis>
